<template>
  <site-link
    :to="$search({ iconPacks: [hyphenatedFamilyName(familyName)], styles: styleName })"
    :class="[`card margin-bottom-0 with-top-tag ${cardColor}`, { ' dark': isDarkTheme }]"
    style="height: 100%"
    @click.native="
      $posthog.capture(posthogCaptureName, {
        family: familyName,
        style: styleName
      })
    "
  >
    <span
      v-if="isNew"
      class="tag top secondary"
    >
      New
    </span>
    <div
      class="header padding-bottom-sm"
      style="clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%)"
    >
      <icon-grid
        :full-style-name="fullStyleName"
        :icons-row-one="cardIconsRowOne"
        :icons-row-two="cardIconsRowTwo"
        :icons-row-three="cardIconsRowThree"
        :is-vertical="true"
      />
    </div>

    <div class="section text-left margin-top-0 padding-top-0 padding-bottom-2xs">
      <card-copy
        :card-color="cardColor"
        :family-name="familyName"
        :style-description="styleDescription"
        :style-name="styleName"
        :is-dark-theme="isDarkTheme"
      />
    </div>
  </site-link>
</template>

<script>
  import { hyphenatedFamilyName } from './styleCardData.js'
  import CardCopy from './CardCopy'
  import IconGrid from './IconGrid'

  export default {
    name: 'StyleCardVertical',

    components: {
      CardCopy,
      IconGrid
    },

    props: {
      familyName: {
        type: String
      },
      cardColor: {
        type: String
      },
      styleDescription: {
        type: String
      },
      styleName: {
        type: String
      },
      fullStyleName: {
        type: String
      },
      isNew: {
        type: Boolean,
        default: false
      },
      isDarkTheme: {
        type: Boolean,
        default: false
      },
      posthogCaptureName: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        cardIconsRowOne: ['faAlarmClock', 'faBadgeCheck', 'faComment'],
        cardIconsRowTwo: ['faFaceSmile', 'faArrowUp', 'faCalendar'],
        cardIconsRowThree: ['faWandMagicSparkles', 'faHouseChimney', 'faStarHalfStroke']
      }
    },

    methods: {
      hyphenatedFamilyName
    }
  }
</script>
